
function setRoomColor(roomname, color) {
    const svgs = document.getElementsByTagName("svg");
    for (let j = 0; j < svgs.length; j++) {
        const room = svgs[j].getElementById(roomname);
        if (room) {
            const area = room.getElementsByClassName("room");
            for (let i = 0; i < area.length; i++) {
                area[i].style.fill = color;
            }
        }
    }
}

function setOpenAvailableLink(roomname, url, title) {
    const svgs = document.getElementsByTagName("svg");
    for (let i = 0; i < svgs.length; i++) {
        const room = svgs[i].getElementById(roomname);
        if (room) {
            const labels = room.getElementsByClassName("label");
            for (let j = 0; j < labels.length; j++) {
                const label = labels[j];
                if (url) {
                    label.addEventListener("click", function () {
                        window.location = url
                    });
                    label.addEventListener("keydown", function (event) {
                        if (event.key === 'Enter') {
                            event.preventDefault()
                            window.location = url
                        }
                    });
                    label.tabIndex = j;
                    label.style.cursor = "pointer";
                }
                if (title) {
                    const titleElement = document.createElementNS("http://www.w3.org/2000/svg", 'title');
                    const subtitle = url ? " available" : "";
                    titleElement.textContent = title + subtitle;
                    label.appendChild(titleElement);
                }
            }
        }
    }
}

function setRoomPulse(room_id) {
    let room = document.getElementById(room_id);
    if (room) {
        if (room.classList.contains("room-active")) {
            clearTimeout(room.intervalID)
        };
        const labels = room.getElementsByClassName("label");
        if (labels.length > 0) {
            labels[0].focus();
        }
        room.scrollIntoView({ 'block': 'start' });
        room.classList.add("animate-pulse");
        room.classList.add("room-active");
        room.intervalID = setTimeout(function () {
            room.classList.remove("animate-pulse");
            room.classList.remove("room-active");
        }, 3000);
    }
}

function searchRooms(searchElement) {
    const labels = document.querySelectorAll("g > text.label");
    let result = [];
    for (let i = 0; i < labels.length; i++) {
        const label = labels[i];
        const labelText = label.textContent.toLowerCase();
        if (labelText.indexOf(searchElement) != -1) {
            const room_id = label.parentElement.id;
            result.push(room_id);
        }
    }
    return result;
}

function onSearch(event) {
    let room_search = event.target.value;
    const searchElement = room_search.toLowerCase().replace(/\s/g, '');
    const rooms = searchRooms(searchElement);
    for (let i = 0; i < rooms.length; i++) {
        const room_id = rooms[i];
        setRoomPulse(room_id);
    }
}

function setRooms() {
    const rooms = JSON.parse(document.getElementById('rooms').textContent);
    for (let i = 0; i < rooms.length; i++) {
        const room = rooms[i]
        setRoomColor(room.name, room.color);
        setOpenAvailableLink(room.name, room.url, room.title);
    }
}

function setSearchBox() {
    document.getElementById('search_room').addEventListener("change", onSearch);
    document.getElementById('search_room').addEventListener("keyup", (event) => {
        if (event.key === "Enter") {
            onSearch(event);
        }
    });
}

export { setRooms, setSearchBox }